import { Dispatch } from 'redux';
import {
  textSettingsChangeFontTypeAction,
  textSettingsChangeFontSizeAction,
  textSettingsChangeLineHeightAction,
  textSettingsChangeIndentRightAction,
  textSettingsChangeIndentLeftAction,
  textSettingsChangeIndentTopAction,
  textSettingsChangeTextColorAction,
  textSettingsChangeIndentRedLineAction,
  textSettingsChangeIndentLetterAction,
  textSettingsChangeIndentWordAction,
} from './actions';

export const textSettingsChangeFontType = (fontType: string) => (dispatch: Dispatch) => {
  dispatch(textSettingsChangeFontTypeAction(fontType));
};

export const textSettingsChangeFontSize = (fontSize: number) => (dispatch: Dispatch) => {
  dispatch(textSettingsChangeFontSizeAction(fontSize));
};

export const textSettingsChangeLineHeight = (lineHeight: number) => (dispatch: Dispatch) => {
  dispatch(textSettingsChangeLineHeightAction(lineHeight));
};

export const textSettingsChangeIndentRight = (indentRight: number) => (dispatch: Dispatch) => {
  dispatch(textSettingsChangeIndentRightAction(indentRight));
};

export const textSettingsChangeIndentLeft = (indentLeft: number) => (dispatch: Dispatch) => {
  dispatch(textSettingsChangeIndentLeftAction(indentLeft));
};

export const textSettingsChangeIndentTop = (indentTop: number) => (dispatch: Dispatch) => {
  dispatch(textSettingsChangeIndentTopAction(indentTop));
};

export const textSettingsChangeTextColor = (textColor: string) => (dispatch: Dispatch) => {
  dispatch(textSettingsChangeTextColorAction(textColor));
};

export const textSettingsChangeIndentRedLine = (indentRedLine: number) => (dispatch: Dispatch) => {
  dispatch(textSettingsChangeIndentRedLineAction(indentRedLine));
};

export const textSettingsChangeIndentLetter = (indentLetter: number) => (dispatch: Dispatch) => {
  dispatch(textSettingsChangeIndentLetterAction(indentLetter));
};

export const textSettingsChangeIndentWord = (indentWord: number) => (dispatch: Dispatch) => {
  dispatch(textSettingsChangeIndentWordAction(indentWord));
};
